export default class ReferralForm{
    constructor(element){
        this.element=document.querySelector(element);
        if(!this.element) return;
        this.overlay = document.querySelector('.referral__closing-overlay');
        this.closeCross = document.querySelector('.referral-form svg');
        this.icon = document.querySelector('.referral');
        this.bindEvents();
        this.init();
    }
    bindEvents(){
        this.overlay.addEventListener('click',(e)=>this.closeForm(e));
        this.closeCross.addEventListener('click',(e)=>this.closeForm(e));
    }
    init(){
        if(window.location.hash == '#referral-reward'){
            this.element.classList.add('referral-form--active');
            this.overlay.classList.add('referral-form--active-close');
        }
    }
    closeForm(e){
        this.element.classList.remove('referral-form--active')
        this.overlay.classList.remove('referral-form--active-close');
        this.icon.classList.remove('referral--hide');
    }
}